import React from 'react';
import styles from './ContactContainer.scss';
import language from '@lang/language';

const ContactContainer = ({data}) => {

	if (!data) {
		return null;
	}

	return (
	  <div className={styles.contactContainer}>
		  {data.content && data.content.map((item, key) => {
			  return (
				<div className={styles.contactItemHolder} key={key}>
					<div className={styles.icon}>
						<img
						  src={item.icon}
						  alt={item.iconAlt}
						  title={item.iconAlt + language.shBGTitle}
						  width={36}
						  height={36}
						/>
					</div>
					<div className={styles.rightHolder}>
						<div
						  className={styles.bigText}
						  dangerouslySetInnerHTML={{__html: item.firstText}}>
						</div>

						<div
						  className={styles.smallText}
						  dangerouslySetInnerHTML={{__html: item.secondText}}>
						</div>
					</div>
				</div>
			  );
		  })}
	  </div>
	);
}

export default ContactContainer;
